export const homepageSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      name: "牛奶片库",
      url: "https://naipianku.com",
      description: "牛奶片库 — 精选牛奶片大全，品质甄选一站购齐。汇聚海量优质牛奶片产品，涵盖儿童牛奶片、成人牛奶片、进口牛奶片等多种品类。",
      telephone: "400-888-9999",
      email: "hello@naipianku.com",
      address: {
        "@type": "PostalAddress",
        addressLocality: "上海",
        addressRegion: "上海",
        addressCountry: "CN",
        streetAddress: "浦东新区张江高科技园区",
      },
      sameAs: ["https://weibo.com/naipianku"],
      logo: "https://naipianku.com/logo.png",
    },
    {
      "@type": "WebSite",
      name: "牛奶片库",
      url: "https://naipianku.com",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://naipianku.com/search?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "WebPage",
      name: "牛奶片库 - 精选牛奶片大全，品质甄选一站购齐",
      url: "https://naipianku.com",
      description:
        "牛奶片库汇聚海量优质牛奶片产品，涵盖儿童牛奶片、成人牛奶片、进口牛奶片等多种品类。严选品牌，提供详尽的成分对比、口感测评与购买指南。",
      isPartOf: { "@type": "WebSite", name: "牛奶片库", url: "https://naipianku.com" },
    },
    {
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "牛奶片和普通奶片有什么区别？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "牛奶片是以纯牛奶或奶粉为主要原料制成的片状乳制品，奶含量通常在80%以上。选购时建议查看配料表，优先选择乳粉排在第一位的产品。",
          },
        },
        {
          "@type": "Question",
          name: "儿童每天吃多少牛奶片合适？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "建议儿童每天食用2-4片即可，不宜过量。牛奶片不能替代正常饮食和牛奶，应作为营养补充零食适量食用。",
          },
        },
        {
          "@type": "Question",
          name: "牛奶片哪个牌子好？如何选择？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "选择牛奶片品牌时，建议从品牌信誉、奶源产地、成分配料和用户评价四个维度综合考虑，优先选择无添加蔗糖、无人工色素的产品。",
          },
        },
        {
          "@type": "Question",
          name: "进口牛奶片和国产牛奶片哪个更好？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "进口牛奶片奶源品质标准较高但价格更贵，国产优质牛奶片性价比更高且品质不断提升。关键在于看产品的奶源、配料和认证。",
          },
        },
        {
          "@type": "Question",
          name: "无糖牛奶片真的不含糖吗？适合糖尿病人食用吗？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "无糖牛奶片每100g含糖量不超过0.5g，通常使用赤藓糖醇等代糖，零GI值不升血糖，糖尿病人可适量食用，但需控制每日摄入量。",
          },
        },
        {
          "@type": "Question",
          name: "牛奶片可以替代牛奶吗？",
          acceptedAnswer: {
            "@type": "Answer",
            text: "牛奶片不能完全替代液态牛奶，加工过程中部分水溶性维生素会损失。建议作为日常营养补充零食，仍需保证每天饮用足量液态奶。",
          },
        },
      ],
    },
  ],
};